export const francePAEn = {
  comments: "Comments",
  rejection_reason: "Rejection Reason",
  invoiced_quantity: "Invoiced Quantity",
  approved_quantity: "Approved Quantity",
  action_description: "Action Description",
  actual_vat_rate: "Actual VAT Rate",
  expected_vat_rate: "Expected VAT Rate",
  reason_description: "Reason Description",
  reason_ext_code: "Reason Ext Code",
  fault_code: "Fault Code",
  fault_message: "Fault Message",
  reason_key: "Reason Key",
  actual_value: "Actual Value",
  expected_value: "Expected Value",
  refusal_reason_ext_code: "Refusal Reason Ext Code",
  refusal_reason_description: "Refusal Reason Description",
  value_date: "Value Date",
  payment_method: "Payment Method",
  payment_amount: "Payment Amount",
  payment_series: "Payment Series",
  payment_code: "Payment Code",
  vat_base: "VAT Base",
  vat_percent: "VAT Percent",
  xml_fault_path: "XML Fault Path",
  vat_amount: "VAT Amount",

  Deposited: "Deposited",
  Deposited_description:
    "Automatic status issued by Invopop when document is deposited",

  IssuedByPlatform: "Issued by Platform",
  IssuedByPlatform_description:
    "Invoice issued and transmitted by supplier's platform",

  ReceivedByPA: "Received by PA",
  ReceivedByPA_description:
    "Invoice received and acknowledged by the Public Authority",

  MadeAvailable: "Made Available",
  MadeAvailable_description: "Invoice made available for processing",

  TakenIntoAccount: "Taken into Account",
  TakenIntoAccount_description:
    "Invoice taken into account and is being processed",

  Approved: "Approved",
  Approved_description: "Invoice fully approved and accepted",

  PartiallyApproved: "Partially Approved",
  PartiallyApproved_description:
    "Invoice partially approved (some items accepted, others rejected)",

  Disputed: "Disputed",
  Disputed_description: "Invoice is disputed and under review",

  Suspended: "Suspended",
  Suspended_description: "Invoice processing suspended, pending clarification",

  Completed: "Completed",
  Completed_description: "Invoice processing completed",

  Refused: "Refused",
  Refused_description: "Invoice refused and rejected by the buyer",

  PaymentAdviceSent: "Payment Advice Sent",
  PaymentAdviceSent_description: "Payment advice has been transmitted",

  PaymentReceived: "Payment Received",
  PaymentReceived_description: "Payment has been received and cashed",

  RejectedByPlatform: "Rejected by Platform",
  RejectedByPlatform_description:
    "Rejected by the platform (validation error, technical issue)",

  "Deposited(200)": "Deposited (200)",
  "IssuedByPlatform(201)": "Issued by Platform (201)",
  "ReceivedByPA(202)": "Received by PA (202)",
  "MadeAvailable(203)": "Made Available (203)",
  "TakenIntoAccount(204)": "Taken into Account (204)",
  "Approved(205)": "Approved (205)",
  "PartiallyApproved(206)": "Partially Approved (206)",
  "Disputed(207)": "Disputed (207)",
  "Suspended(208)": "Suspended (208)",
  "Completed(209)": "Completed (209)",
  "Refused(210)": "Refused (210)",
  "PaymentAdviceSent(211)": "Payment Advice Sent (211)",
  "PaymentReceived(212)": "Payment Received (212)",
  "RejectedByPlatform(213)": "Rejected by Platform (213)",
};
